import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MasterData from '../../data/MasterData'

const MainRouteMap = ({ locale, themeName }) => {
  const getStationsByLineId = (lineId) => {
    return MasterData.trainPositionTab(lineId).stations.map(station => MasterData.station(station.id))
  }

  const stations = getStationsByLineId(1)

    return (
      <ul className="d-Routemap-station">
        <li className="d-Routemap-stationItem d-Routemap-stationItem--first">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[0][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress is_none is_terminal_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_none is_terminal_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_none is_terminal_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_none is_terminal_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[1][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[2][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[3][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[4][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[5][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[6][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem d-Routemap-stationItem--lg">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[7][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromMainToShinyokohama is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromMainToShinyokohama is_local"></div>
          </div>
          <Link to={`/lines/for_tokyu/route_map`} className={`d-Routemap-lineSwitch d-Routemap-lineSwitch-${themeName} d-Routemap-lineSwitch--fromMainToShinyokohama`}>
            <p className="d-Routemap-lineSwitchText">{MasterData.line(3)[`name_${locale}`]}</p>
          </Link>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[8][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress is_comltdexp_stop"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[9][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromMainToIzumino is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromMainToIzumino is_express"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromMainToIzumino is_rapid"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--fromMainToIzumino is_local"></div>
          </div>
          <Link to={`/lines/izumino/route_map`} className={`d-Routemap-lineSwitch d-Routemap-lineSwitch-${themeName} d-Routemap-lineSwitch--fromMainToIzumino`}>
            <p className="d-Routemap-lineSwitchText">{MasterData.line(2)[`name_${locale}`]}</p>
          </Link>
        </li>
        <li className="d-Routemap-stationItem d-Routemap-stationItem--xl">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[10][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[11][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[12][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[13][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[14][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[15][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[16][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_station"></div>
          </div>
        </li>
        <li className="d-Routemap-stationItem">
          <div className="d-Routemap-stationInfo">
            <p className="d-Routemap-stationName">{stations[17][`name_${locale}`]}</p>
          </div>
          <div className="d-Routemap-line">
            <div className="d-Routemap-lineItem d-Routemap-lineItem--01 is_limitedExpress is_terminal_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--02 is_express is_terminal_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--03 is_rapid is_terminal_station"></div>
            <div className="d-Routemap-lineItem d-Routemap-lineItem--04 is_local is_terminal_station"></div>
          </div>
        </li>
      </ul>
    )
}

MainRouteMap.propTypes = {
  locale: PropTypes.string.isRequired,
  themeName: PropTypes.string.isRequired,
}
export default MainRouteMap